import React from "react";
import {observer} from "mobx-react";
import {mouseState} from "./state/mouseState";
import themeState from "./state/themeState";
import experimentState, {ApplicationState} from "./state/experimentState";

class CalibrationBox extends React.Component {
    constructor(props) {
        super(props)
        this.state = {count: 0}
    }

    handleMouseCenterBox(evt) {
        if (evt.type === "mouseenter") {
            // mouseState.setMouseEnter(evt.pageX, evt.pageY);
            experimentState.setFakeMouseVisibility(true);
            mouseState.setMouseForce(evt.pageX, evt.pageY)
            console.log("hello",true);
            experimentState.setApplicationState(ApplicationState.APP_CHAT);
            if (this.state.count ===0) {
                experimentState.emptyMessages()
            }
            this.setState({count: this.state.count + 1})

        }
    }

    render() {
        let more_than_once = this.state.count ? <p>Uw muis heeft zich buiten het venster begeven.</p> : ""
        let again = this.state.count ? "weer" : ""
        return <div
            style={{
                display: experimentState.application_state === ApplicationState.APP_MOUSE_CALIBRATION ? "block" : "none"}}>
            <div
                onMouseEnter={this.handleMouseCenterBox.bind(this)}
                style={{
                    position: "absolute",
                    maxWidth: "5%",
                    width: "50px",
                    maxHeight: "5%",
                    height: "50px",
                    top: "50%",
                    left: "50%",
                    backgroundColor: themeState.colour_primary
                }}></div>
            {more_than_once}
            <p>Beweeg de muis alstublieft {again} naar het {themeState.colour_primary_name} vierkant in het midden van het scherm</p>
        </div>
    }
}

CalibrationBox = observer(CalibrationBox);
export default CalibrationBox;